import { Component, h, Host, Prop } from "@stencil/core";

const baseClass = "uic-flyout";

/**
 * @slot content - Content of the flyout panel
 * @slot footer - Footer `uic-button` elements with variant `footer` or `footer-primary`
 */
@Component({
    tag: "uic-flyout",
    styleUrl: "flyout.scss",
    shadow: false
})
export class Flyout {
    /** Unique name used to identify the flyout */
    @Prop() readonly name: string;
    /** Flag that indicates if the flyout is opened (visible) or not (hidden) */
    @Prop() readonly opened: boolean = false;
    /** Horizontal position of the flyout */
    @Prop() readonly position: "left" | "right" = "left";

    render() {
        const { opened, position } = this;
        return (
            <Host
                class={{
                    [`${baseClass}--${position}`]: typeof position !== "undefined",
                    [`${baseClass}--opened`]: opened
                }}
            >
                <div class={`${baseClass}__content`}>
                    <slot name='content' />
                </div>
                <uic-footer class={`${baseClass}__footer`}>
                    <slot name='footer' />
                </uic-footer>
            </Host>
        );
    }
}
